import { StyleSheet } from 'aphrodite';
import { DefaultBorder } from '../../../web/styles/styles';
import { HeaderHeight } from '../../containers/AdminDashboardPageLayout/styles';

export const styleSheet = StyleSheet.create({
	container: {
		background: '#fff',
	},
	content: {
		alignItems: 'center',
		borderBottom: DefaultBorder,
		boxSizing: 'border-box',
		display: 'flex',
		height: HeaderHeight,
		justifyContent: 'space-between',
		minHeight: HeaderHeight,
	},
	navItem: {},
	toaster: {
		left: '50%',
		position: 'fixed',
		top: 17,
		transform: 'translate(-50%)',
	},
});
